export enum HearingTestTypes {
    TONAL = "tonal",
    NOISE = "noise",
    WORDS = "words",
    NUMBERS = "numbers"
}
